import { IonContent, IonPage, IonRow, IonText } from '@ionic/react';
import { useEffect } from 'react';

import { DashboardAppInfoTable } from '@/components/DashboardAppInfoTable/DashboardAppInfoTable';
// Components
import { QuickLinkGrid } from '@/components/QuickLinkGrid';
import { ReportCardGrid } from '@/components/ReportCardGrid';
import { SectionHeader } from '@/components/SectionHeader';
import { Spinner } from '@/components/Spinner/Spinner';

// Hooks
import { useReportContext } from '@/contexts/reportContext';
import { useUserInfoContext } from '@/contexts/userInfoContext';

// Styles
import styles from '@/pages/Dashboard.module.css';

export const Dashboard: React.FC = () => {
  const { userInfo } = useUserInfoContext();
  const { reportInfoDict, isLoading, isError } = useReportContext();

  useEffect(() => {
    console.log('reportInfoDict', reportInfoDict);
  }, [reportInfoDict]);

  useEffect(() => {
    if (isError) {
      console.log('Error:', isError);
    }
  }, [isError]);

  return (
    <IonPage id='main'>
      <IonContent className={styles.content} color='light' id='main'>
        <SectionHeader
          title={`Welcome back, ${userInfo?.firstName}`}
          // subTitle='Tempor do adipisicing anim nulla excepteur.'
        />

        <QuickLinkGrid />

        {isLoading ? (
          <>
            <IonRow className='ion-justify-content-center'>
              <div>
                <Spinner />
                <IonText className={styles['sub-title']}>Loading data please wait...</IonText>
              </div>
            </IonRow>
          </>
        ) : (
          <ReportCardGrid data={reportInfoDict} />
        )}

        <DashboardAppInfoTable />
      </IonContent>
    </IonPage>
  );
};
